import { Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ButtonBack = (props) => {
  return (
    <div>
      <Button
        variant={props.variant || 'text'}
        color='secondary'
        size={props.size || 'small'}
        startIcon={<ArrowBackIcon />}
        onClick={props.onClick || props.history.goBack}
        sx={{ mb: Number(props.marginBotton) || 1, fontWeight: 'bold' }}
        aria-label='Volver a la página anterior'
      >
        Atrás
      </Button>
    </div>
  );
};

export default withRouter(ButtonBack);
